enum CurrencySymbols {
  AZN = '₼',
  USD = '$',
  EUR = '€'
}

type CurrencyKey = keyof typeof CurrencySymbols;

export const getSymbolFromCurrency = (
  currency?: string
): CurrencySymbols | string => {
  const currencyKey = currency as CurrencyKey;
  return CurrencySymbols[currencyKey] || currency;
};
